import React, { useEffect, useState } from "react";
import { apiUrl, getApiUrl } from "../../config/config";
import { useHandleActionItem } from "../../hooks/useHandleActionItem";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "./TableBody.css"; // Importa el archivo CSS
import Swal from "sweetalert2";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

const TableBody = ({ table }) => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState([]);
	const { handleDelete } = useHandleActionItem();
	const [shouldRefetch, setShouldRefetch] = useState(false);
	const [users, setUsers] = useState();
	const [accounts, setAccounts] = useState();
	const [selectedUser, setSelectedUser] = useState();
	const [selectedAccount, setSelectedAccount] = useState();
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");

	// Estados para la paginación
	const [currentPage, setCurrentPage] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(20); // Estado para la cantidad de filas por página
	const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

	// Estados para el modal de clasificación
	const [showClassificationModal, setShowClassificationModal] = useState(false);
	const [tournamentParticipants, setTournamentParticipants] = useState([]);
	const [selectedTournament, setSelectedTournament] = useState(null);
	const [loadingParticipants, setLoadingParticipants] = useState(false);

	useEffect(() => {
		fetchData();
		// getUsers();
	}, []);

	useEffect(() => {
		if (shouldRefetch) {
			fetchData();
			setShouldRefetch(false);
		}
	}, [shouldRefetch]);

	useEffect(() => {
		if (data.length > 0) {
			setIsLoading(false);
		}
	}, [data]);

	const handleAddAccounts = (send) => {
		navigate(`/${table}Details`, { state: send });
	};

	const doDelete = (item) => {
		const data = {
			userId: item["ID Usuario"] ? item["ID Usuario"] : "",
			id: item.ID ? item.ID : "",
			accountId: item["ID Cuenta"] ? item["ID Cuenta"] : "",
			amount: item.Monto ? item.Monto : "",
		};

		const res = handleDelete(data, table);
		if (res) {
			setTimeout(() => {
				setShouldRefetch(true);
			}, 1000);
		}
	};

	const fetchData = async () => {
		setIsLoading(true);
		let url = apiUrl;
		const ibAppUrl = await getApiUrl();
		if (ibAppUrl) {
			url = ibAppUrl;
		}

		try {
			const response = await fetch(url + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					table: table,
					...(table === "ibUsers" || table === "ibPurchases" ? { userId: JSON.parse(localStorage.getItem("userProfile")).id } : {}),
				}),
			});

			if (response.ok) {
				let data = await response.json();
				console.log("LISTA DATA:", data);
				const excludeKeys = [
					"cardDetails",
					"realToken",
					"demoToken",
					// "image",
					"profileImage",
					"actieCustomer",
					"activeDrawings",
					"activeCustomer",
					// "description",
					"buyTo",
					"bankResponse",
					"invoiceId",
					"address",
					"profit",
					"statusDrawings",
					"drawerName",
					"drawings",
					"deleted",
				];

				const translatedData = data.data.reverse().map((item) => {
					const translatedItem = {};
					for (const key in item) {
						if (excludeKeys.includes(key)) continue;

						let translatedKey;
						switch (key) {
							case "id":
								translatedKey = "ID";
								break;
							case "userId":
								translatedKey = "ID Usuario";
								break;
							case "type":
								translatedKey = "Tipo";
								break;
							case "amount":
								translatedKey = "Monto";
								break;
							case "status":
								translatedKey = "Estado";
								break;
							case "createdAt":
								translatedKey = "Creado";
								break;
							case "traderId":
								translatedKey = "Trader";
								break;
							case "accountId":
								translatedKey = "ID Cuenta";
								break;
							case "name":
								translatedKey = "Nombre";
								break;
							case "email":
								translatedKey = "Correo";
								break;
							case "currency":
								translatedKey = "Moneda";
								break;
							case "date":
								translatedKey = "Creado";
								break;
							case "purchaseId":
								translatedKey = "Compra";
								break;
							case "ticketId":
								translatedKey = "Ticket";
								break;
							case "volume":
								translatedKey = "Volumen";
								break;
							case "price":
								translatedKey = "Precio";
								break;
							case "stopLoss":
								translatedKey = "Stop Loss";
								break;
							case "takeProfit":
								translatedKey = "Take Profit";
								break;
							case "profit":
								translatedKey = "Profit";
								break;
							case "percent":
								translatedKey = "Porcentaje";
								break;
							case "role":
								translatedKey = "Rol";
								break;
							case "balance":
								translatedKey = "Balance";
								break;
							case "country":
								translatedKey = "País";
								break;
							case "commision":
								translatedKey = "Comisión";
								break;
							case "stopOut":
								translatedKey = "Cierre";
								break;
							case "leveragedAmount":
								translatedKey = "Monto Apalancado";
								break;
							case "description":
								translatedKey = "Descripción";
								break;
							case "transactionId":
								translatedKey = "ID Transacción";
								break;
							case "productId":
								translatedKey = "ID Producto";
								break;
							case "lots":
								translatedKey = "Lotes";
								break;
							case "symbol":
								translatedKey = "Símbolo";
								break;
							case "entryPrice":
								translatedKey = "Precio Entrada";
								break;
							case "exitPrice":
								translatedKey = "Precio Salida";
								break;
							case "ib":
								translatedKey = "IB";
								break;
							case "ibCode":
								translatedKey = "Código IB";
								break;
							case "ibFollow":
								translatedKey = "Sigue IB";
								break;
							case "contractSize":
								translatedKey = "Tamaño Contrato";
								break;
							case "tickSize":
								translatedKey = "Tamaño Tick";
								break;
							case "marginPercent":
								translatedKey = "Porcentaje Margen";
								break;
							case "swapBuy":
								translatedKey = "Swap Buy";
								break;
							case "swapSell":
								translatedKey = "Swap Sell";
								break;
							case "spread":
								translatedKey = "Spread";
								break;
							case "cryptoAddress":
								translatedKey = "Dirección USDT";
								break;
							case "minTrade":
								translatedKey = "Trade Mínimo";
								break;
							case "maxTrade":
								translatedKey = "Trade Máximo";
								break;
							case "margin":
								translatedKey = "Margen";
								break;
							case "pendingAmount":
								translatedKey = "Pendiente";
								break;
							case "chartType":
								translatedKey = "Tipo";
								break;
							case "address":
								translatedKey = "Dirección";
								break;
							case "paymentStatus":
								translatedKey = "Estado Pago";
								break;
							case "expireAt":
								translatedKey = "Expira";
								break;
							case "event_date":
								translatedKey = "Fecha Evento";
								break;
							case "event_type":
								translatedKey = "Tipo Evento";
								break;
							case "title":
								translatedKey = "Título";
								break;
							case "importance":
								translatedKey = "Importancia";
								break;
							case "time":
								translatedKey = "Tiempo";
								break;
							// Campos de torneos
							case "name":
								translatedKey = "Nombre";
								break;
							case "description":
								translatedKey = "Descripción";
								break;
							case "type":
								translatedKey = "Tipo";
								break;
							case "startDate":
								translatedKey = "Fecha Inicio";
								break;
							case "endDate":
								translatedKey = "Fecha Fin";
								break;
							case "registrationDeadline":
								translatedKey = "Límite Registro";
								break;
							case "maxParticipants":
								translatedKey = "Max Participantes";
								break;
							case "currentParticipants":
								translatedKey = "Participantes";
								break;
							case "entryFee":
								translatedKey = "Cuota Entrada";
								break;
							case "prizePool":
								translatedKey = "Premio Total";
								break;
							case "status":
								translatedKey = "Estado";
								break;
							case "rules":
								translatedKey = "Reglas";
								break;
							case "prizeFirst":
								translatedKey = "1er Premio";
								break;
							case "prizeSecond":
								translatedKey = "2do Premio";
								break;
							case "prizeThird":
								translatedKey = "3er Premio";
								break;
							case "closeTime":
								translatedKey = "Tiempo Cierre";
								break;
							case "appCode":
								translatedKey = "Código App";
								break;
							case "timeFrame":
								translatedKey = "Temporalidad";
								break;
							case "positionStatus":
								translatedKey = "Estado de Posición";
								break;
							case "admin":
								translatedKey = "Admin";
								break;
							case "copyFrom":
								translatedKey = "Copia De";
								break;
							case "copyTo":
								translatedKey = "Copia A";
								break;
							case "image":
								translatedKey = "Imagen";
								break;
							case "accountType":
								translatedKey = "Tipo de Cuenta";
								break;
							default:
								translatedKey = key;
						}

						translatedItem[translatedKey] = item[key];
					}

					// Agregar columna de tipo de cuenta para copyTrading
					if (table === "copyTrading" && item.copyFrom) {
						translatedItem["Tipo Cuenta"] = String(item.copyFrom).startsWith("CR") ? "Real" : "Demo";
					}

					return translatedItem;
				});

				setData(translatedData);
				setIsLoading(false);
			} else {
				console.error("Error al registrar:", response.status, response.statusText);
				setIsLoading(false);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
			setIsLoading(false);
		}
	};

	const getUsers = async () => {
		setIsLoading(true);
		try {
			const response = await fetch(apiUrl + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ table: "users" }),
			});
			if (response.ok) {
				let data = await response.json();
				console.log("USERS:", data);
				setUsers(data.data);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
		}
	};

	const formatAccounts = (accData, userId) => {
		return [
			{
				id: accData.realAcc,
				type: "real",
				token: accData.realToken,
				userId: userId,
			},
			{
				id: accData.demoAcc,
				type: "demo",
				token: accData.demoToken,
				userId: userId,
			},
		];
	};

	const getAccounts = async (e) => {
		const userId = e.target.value;

		try {
			const response = await fetch(apiUrl + "/getList", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ table: "accounts", userId }),
			});

			if (response.ok) {
				const result = await response.json();
				const data = result.data;

				// Convertimos el objeto en un array compatible
				const formattedAccounts = formatAccounts(data, userId);
				setAccounts(formattedAccounts);
			}
		} catch (error) {
			console.error("Error al obtener cuentas:", error);
		}
	};

	const getPositions = async (e) => {
		e.preventDefault();
		const accountId = e.target.value;
		setIsLoading(true);
		if (accountId) {
			try {
				const response = await fetch(apiUrl + "/getList2", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ table: "positions", accountId: accountId }),
				});
				if (response.ok) {
					let data = await response.json();
					console.log("POSITIONS:", data);
					setData(data);
				}
			} catch (error) {
				console.error("Error al realizar la solicitud:", error);
			}
		}
		setIsLoading(false);
	};

	// Manejar el cambio de página
	const handlePageClick = (event) => {
		setCurrentPage(event.selected);
	};

	// Manejar el cambio de cantidad de filas por página
	const handleItemsPerPageChange = (event) => {
		setItemsPerPage(Number(event.target.value));
		setCurrentPage(0); // Reiniciar a la primera página
	};

	const handleCreateIb = async (item) => {
		try {
			const data = {
				userId: item.ID,
				name: item.Nombre,
				email: item.Correo,
			};
			const response = await fetch(apiUrl + "/createIb", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});
			console.log("IB created successfully:", response.data);
			Toast.fire({
				icon: "success",
				title: "IB Creado satisfactoriamente",
				background: "#1e2836",
			});
		} catch (error) {
			console.error("Error creating IB:", error);
		}
	};

	// Función para obtener participantes del torneo
	const handleViewClassification = async (item) => {
		console.log("ITEM", item);
		setSelectedTournament(item);
		setShowClassificationModal(true);
		setLoadingParticipants(true);

		try {
			let url = apiUrl;
			const ibAppUrl = await getApiUrl();
			if (ibAppUrl) {
				url = ibAppUrl;
			}

			const response = await fetch(url + "/getTournamentParticipants", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					tournamentId: item.ID,
				}),
			});

			const responseData = await response.json();

			if (responseData.ok) {
				setTournamentParticipants(responseData.data || []);
			} else {
				Toast.fire({
					icon: "error",
					title: responseData.message || "Error al cargar participantes",
					background: "#1e2836",
					color: "#fff",
				});
				setTournamentParticipants([]);
			}
		} catch (error) {
			console.error("Error loading tournament participants:", error);
			Toast.fire({
				icon: "error",
				title: "Error de conexión",
				background: "#1e2836",
				color: "#fff",
			});
			setTournamentParticipants([]);
		} finally {
			setLoadingParticipants(false);
		}
	};

	// Funciones específicas para torneos
	const handleStartTournament = async (item) => {
		try {
			// Mostrar confirmación
			const result = await Swal.fire({
				title: "¿Iniciar Torneo?",
				text: `¿Está seguro de que desea iniciar el torneo "${item.Nombre}"?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Sí, iniciar",
				cancelButtonText: "Cancelar",
				background: "#1e2836",
				color: "#fff",
			});

			if (result.isConfirmed) {
				let url = apiUrl;
				const ibAppUrl = await getApiUrl();
				if (ibAppUrl) {
					url = ibAppUrl;
				}

				const response = await fetch(url + "/startTournament", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						tournamentId: item.ID,
						action: "start",
					}),
				});

				const responseData = await response.json();

				if (responseData.ok) {
					Toast.fire({
						icon: "success",
						title: "Torneo iniciado correctamente",
						background: "#1e2836",
						color: "#fff",
					});
					setShouldRefetch(true);
				} else {
					Toast.fire({
						icon: "error",
						title: responseData.message || "Error al iniciar torneo",
						background: "#1e2836",
						color: "#fff",
					});
				}
			}
		} catch (error) {
			console.error("Error starting tournament:", error);
			Toast.fire({
				icon: "error",
				title: "Error de conexión",
				background: "#1e2836",
				color: "#fff",
			});
		}
	};

	const handleEndTournament = async (item) => {
		try {
			// Mostrar confirmación
			const result = await Swal.fire({
				title: "¿Finalizar Torneo?",
				text: `¿Está seguro de que desea finalizar el torneo "${item.Nombre}"? Se calcularán los ganadores automáticamente.`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#28a745",
				cancelButtonColor: "#d33",
				confirmButtonText: "Sí, finalizar",
				cancelButtonText: "Cancelar",
				background: "#1e2836",
				color: "#fff",
			});

			if (result.isConfirmed) {
				let url = apiUrl;
				const ibAppUrl = await getApiUrl();
				if (ibAppUrl) {
					url = ibAppUrl;
				}

				const response = await fetch(url + "/endTournament", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						tournamentId: item.ID,
						action: "end",
					}),
				});

				const responseData = await response.json();

				if (responseData.ok) {
					Toast.fire({
						icon: "success",
						title: "Torneo finalizado correctamente",
						text: responseData.winner ? `Ganador: ${responseData.winner}` : "",
						background: "#1e2836",
						color: "#fff",
					});
					setShouldRefetch(true);
				} else {
					Toast.fire({
						icon: "error",
						title: responseData.message || "Error al finalizar torneo",
						background: "#1e2836",
						color: "#fff",
					});
				}
			}
		} catch (error) {
			console.error("Error ending tournament:", error);
			Toast.fire({
				icon: "error",
				title: "Error de conexión",
				background: "#1e2836",
				color: "#fff",
			});
		}
	};

	const filteredData = data.filter((item) => {
		if (table === "positionsHistory") {
			const userFilter = selectedUser ? String(item["userID"]) === String(selectedUser) : true;
			const accountFilter = selectedAccount ? String(item["accountID"]) === String(selectedAccount) : true;
			const searchFilter = Object.entries(item).some(
				([key, val]) => key !== "Creado" && String(val).toLowerCase().includes(searchTerm.toLowerCase())
			);
			return userFilter && accountFilter && searchFilter;
		}

		// Filtro general
		return Object.entries(item).some(([key, val]) => key !== "Creado" && String(val).toLowerCase().includes(searchTerm.toLowerCase()));
	});

	const offset = currentPage * itemsPerPage;
	const currentPageData = filteredData.slice(offset, offset + itemsPerPage);
	const pageCount = Math.ceil(filteredData.length / itemsPerPage);

	const ensureKeyOrder = (keys) => {
		const idKey = keys.includes("ID") ? ["ID"] : [];
		const imageKey = keys.includes("Imagen") ? ["Imagen"] : [];
		const rest = keys.filter((key) => key !== "ID" && key !== "Imagen");
		return [...idKey, ...imageKey, ...rest];
	};

	const ensureEntryOrder = (entries) => {
		const idEntry = entries.find(([key]) => key === "ID");
		const imageEntry = entries.find(([key]) => key === "Imagen");
		const rest = entries.filter(([key]) => key !== "ID" && key !== "Imagen");
		return [...(idEntry ? [idEntry] : []), ...(imageEntry ? [imageEntry] : []), ...rest];
	};

	const orderedHeaders = ensureKeyOrder(Object.keys(currentPageData[0] || {}));

	return (
		<div>
			<div className="table-responsive">
				<div className="input-group mb-4">
					<div className="flex-fill position-relative">
						<div className="input-group">
							<span className="input-group-text">
								<i className="fa fa-search"></i>
							</span>
							<input
								type="text"
								className="form-control ps-35px"
								placeholder="Buscar"
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</div>
					</div>
				</div>

				{table === "positionsHistory" && (
					<div>
						<div className="input-group mb-4">
							<div className="flex-fill position-relative me-2">
								<div className="input-group">
									<span className="input-group-text">
										<i className="fa fa-user"></i>
									</span>
									<select
										className="form-control ps-35px"
										value={selectedUser}
										onChange={(e) => {
											setSelectedUser(e.target.value);
											getAccounts(e);
										}}>
										<option value="">Todos los usuarios</option>
										{users &&
											users.length > 0 &&
											users.map((user) => (
												<option key={user.id} value={user.id}>
													{user.id} - {user.name} - {user.email}
												</option>
											))}
									</select>
								</div>
							</div>
							<div className="flex-fill position-relative">
								<div className="input-group">
									<span className="input-group-text">
										<i className="fa fa-briefcase"></i>
									</span>
									<select
										className="form-control ps-35px"
										value={selectedAccount ? selectedAccount.id : ""}
										onChange={(e) => {
											setSelectedAccount(e.target.value);
											console.log("ACCOUNTTTTTT:", e.target.value);
										}}>
										<option value="">Todas las cuentas</option>
										{accounts &&
											accounts.length > 0 &&
											accounts.map((account) => (
												<option key={account.id} value={account.id}>
													{account.id} - {account.type}
												</option>
											))}
									</select>
								</div>
							</div>
						</div>
						<div className="d-flex gap-3 mt-3 mb-4">
							<div className="input-group">
								<span className="input-group-text">
									<i className="fa fa-calendar"></i>
								</span>
								<input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
							</div>
							<div className="input-group">
								<span className="input-group-text">
									<i className="fa fa-calendar"></i>
								</span>
								<input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
							</div>
						</div>
					</div>
				)}

				<div className="d-flex justify-content-between align-items-center mb-3">
					<div>
						<label htmlFor="itemsPerPage">Filas por página:</label>
						<select id="itemsPerPage" value={itemsPerPage} onChange={handleItemsPerPageChange}>
							<option value={10}>10</option>
							<option value={20}>20</option>
							<option value={50}>50</option>
							<option value={100}>100</option>
						</select>
					</div>
				</div>
				{data.length === 0 && !isLoading && (
					<div className="text-center">
						<h1>No se encuentran datos</h1>
					</div>
				)}
				{data.length === 0 && isLoading && (
					<div className="text-center">
						<div className="spinner-border text-primary" role="status">
							<span className="visually-hidden">Cargando...</span>
						</div>
					</div>
				)}
				{data.length > 0 && (
					<>
						<table className="table table-hover text-nowrap">
							<thead>
								<tr>
									{orderedHeaders.map((key, i) => (
										<th key={i} className="align-middle">
											{key}
										</th>
									))}
									<th className="pt-0 pb-2">Acción</th>
								</tr>
							</thead>
							{currentPageData.map((item, index) => (
								<tbody key={index}>
									<tr>
										{ensureEntryOrder(Object.entries(item)).map(([key, value], i) => (
											<td
												className="align-middle"
												key={i}
												style={{ maxWidth: key === "Reglas" || key === "Descripción" ? "200px" : "auto" }}>
												{key === "Estado" ? (
													typeof value === "string" && value === "1" ? (
														"🟢"
													) : typeof value === "string" && value === "0" ? (
														"🔴"
													) : value === "REGISTRATION" ? (
														"📝 En Registro"
													) : value === "UPCOMING" ? (
														"⏳ Próximo"
													) : value === "IN_PROGRESS" ? (
														"🏆 En Progreso"
													) : value === "COMPLETED" ? (
														"✅ Completado"
													) : value === "CANCELLED" ? (
														"❌ Cancelado"
													) : (
														value
													)
												) : key === "Rol" ? (
													value === "customer" ? (
														"Cliente"
													) : (
														value
													)
												) : key === "Creado" || key === "Fecha Inicio" || key === "Fecha Fin" || key === "Límite Registro" ? (
													new Date(value).toLocaleString().replace("T", " ").replace("Z", "") // Formatear la fecha
												) : key === "Expira" ? (
													new Date(value).toLocaleString().replace("T", " ").replace("Z", "") // Formatear la fecha
												) : key === "Contraseña" ? (
													"********"
												) : key === "Reglas" || key === "Descripción" ? (
													<div
														style={{
															maxHeight: "60px",
															overflow: "hidden",
															textOverflow: "ellipsis",
															whiteSpace: "nowrap",
															cursor: "pointer",
														}}
														title={value} // Mostrar texto completo al hacer hover
													>
														{value && value.length > 50 ? `${value.substring(0, 50)}...` : value}
													</div>
												) : key === "Imagen" ? (
													value ? (
														<img
															src={value}
															alt="Imagen"
															style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "4px" }}
														/>
													) : (
														"-"
													)
												) : key === "Cuota Entrada" || key === "Premio Total" ? (
													`$${parseFloat(value || 0).toFixed(2)}`
												) : key === "Tipo Cuenta" ? (
													<span
														style={{
															backgroundColor: value === "Real" ? "rgba(0, 255, 0, 0.2)" : "rgba(255, 165, 0, 0.2)",
															color: value === "Real" ? "#00ff00" : "#ff8c00",
															padding: "4px 12px",
															borderRadius: "12px",
															fontWeight: "600",
															fontSize: "12px",
															display: "inline-block",
															border:
																value === "Real"
																	? "1px solid rgba(0, 255, 0, 0.3)"
																	: "1px solid rgba(255, 165, 0, 0.3)",
														}}>
														{value}
													</span>
												) : (
													value
												)}
											</td>
										))}
										<td className="align-middle">
											{table === "users" && (
												<button
													onClick={() => handleCreateIb(item)}
													className="btn btn-outline-info btn-sm mr-3"
													style={{ marginRight: "0.75rem" }}>
													<i className="fa fa-user-plus"></i>
												</button>
											)}
											{table === "tournaments" && (
												<>
													{/* Botón Ver Clasificación - Siempre visible */}
													<button
														onClick={() => handleViewClassification(item)}
														className="btn btn-outline-info btn-sm mr-2"
														style={{ marginRight: "0.5rem" }}
														title="Ver Clasificación">
														<i className="fa fa-list-ol"></i>
													</button>
													{/* Botón Iniciar - Solo mostrar si el estado permite iniciar */}
													{(item.Estado === "REGISTRATION" || item.Estado === "UPCOMING") && (
														<button
															onClick={() => handleStartTournament(item)}
															className="btn btn-outline-success btn-sm mr-2"
															style={{ marginRight: "0.5rem" }}
															title="Iniciar Torneo">
															<i className="fa fa-play"></i>
														</button>
													)}
													{/* Botón Finalizar - Solo mostrar si está en progreso */}
													{item.Estado === "IN_PROGRESS" && (
														<button
															onClick={() => handleEndTournament(item)}
															className="btn btn-outline-warning btn-sm mr-2"
															style={{ marginRight: "0.5rem" }}
															title="Finalizar Torneo">
															<i className="fa fa-stop"></i>
														</button>
													)}
													{/* Botones estándar de editar y eliminar */}
													<button
														onClick={() => handleAddAccounts({ type: "edit", data: item })}
														className="btn btn-outline-primary btn-sm mr-2"
														style={{ marginRight: "0.5rem" }}
														title="Editar">
														<i className="fa fa-edit"></i>
													</button>
													<button onClick={() => doDelete(item)} className="btn btn-outline-danger btn-sm" title="Eliminar">
														<i className="fa fa-trash"></i>
													</button>
												</>
											)}
											{table !== "accounts" && table !== "positionHistory" && table !== "tournaments" && (
												<>
													<button
														onClick={() => handleAddAccounts({ type: "edit", data: item })}
														className="btn btn-outline-primary btn-sm mr-3"
														style={{ marginRight: "0.75rem" }}>
														<i className="fa fa-edit"></i>
													</button>
													<button onClick={() => doDelete(item)} className="btn btn-outline-danger btn-sm">
														<i className="fa fa-trash"></i>
													</button>
												</>
											)}
										</td>
									</tr>
								</tbody>
							))}
						</table>
						<ReactPaginate
							previousLabel={<i className="fa fa-chevron-left"></i>}
							nextLabel={<i className="fa fa-chevron-right"></i>}
							pageCount={pageCount}
							onPageChange={handlePageClick}
							containerClassName={"pagination"}
							previousLinkClassName={"pagination__link"}
							nextLinkClassName={"pagination__link"}
							disabledClassName={"pagination__link--disabled"}
							activeClassName={"pagination__link--active"}
							pageClassName={"pagination__page"}
							breakClassName={"pagination__break"}
						/>
					</>
				)}
			</div>

			{/* Modal de Clasificación de Torneo */}
			{showClassificationModal && (
				<div
					className="modal fade show"
					style={{
						display: "block",
						backgroundColor: "rgba(0,0,0,0.8)",
						backdropFilter: "blur(5px)",
						paddingTop: "60px",
					}}>
					<div className="modal-dialog modal-xl">
						<div
							className="modal-content"
							style={{
								backgroundColor: "transparent",
								color: "white",
								boxShadow: "inset 0 0 10px #000, inset 0 0 20px rgba(69, 153, 217, 0.9)",
								backdropFilter: "blur(5px)",
								border: "1px solid rgba(69, 153, 217, 0.3)",
								borderRadius: "15px",
							}}>
							<div className="modal-header" style={{ borderBottom: "1px solid rgba(69, 153, 217, 0.3)" }}>
								<h5
									className="modal-title text-white"
									style={{
										fontFamily: "'Montserrat', sans-serif",
										fontWeight: "600",
									}}>
									🏆 {selectedTournament?.Nombre || selectedTournament?.name} 🏆
								</h5>
								<button
									type="button"
									className="btn-close btn-close-white"
									onClick={() => setShowClassificationModal(false)}
									style={{
										filter: "drop-shadow(0 0 5px rgba(69, 153, 217, 0.5))",
									}}
									aria-label="Cerrar"></button>
							</div>
							<div className="modal-body">
								{loadingParticipants ? (
									<div className="text-center py-4">
										<div className="spinner-border text-primary" role="status">
											<span className="visually-hidden">Cargando...</span>
										</div>
										<p className="text-white mt-2">Cargando participantes...</p>
									</div>
								) : tournamentParticipants.length === 0 ? (
									<div className="text-center py-4">
										<i className="fa fa-users fa-3x text-muted mb-3"></i>
										<p className="text-white">No hay participantes registrados en este torneo</p>
									</div>
								) : (
									<div
										className="table-responsive"
										style={{
											maxHeight: "60vh",
											overflowY: "auto",
											scrollbarWidth: "thin",
											scrollbarColor: "rgba(69, 153, 217, 0.7) transparent",
										}}
										onWheel={(e) => e.stopPropagation()}>
										<table
											className="table table-striped"
											style={{
												backgroundColor: "rgba(69, 153, 217, 0.1)",
												color: "white",
											}}>
											<thead style={{ backgroundColor: "rgba(69, 153, 217, 0.3)" }}>
												<tr>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Pos</th>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Participante</th>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Cuenta</th>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Balance Actual</th>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Estado</th>
													<th style={{ color: "white", fontFamily: "'Montserrat', sans-serif" }}>Registrado</th>
												</tr>
											</thead>
											<tbody>
												{tournamentParticipants.map((participant, index) => (
													<tr key={participant.participantId}>
														<td>
															{participant.position
																? participant.position === 1
																	? "🥇"
																	: participant.position === 2
																	? "🥈"
																	: participant.position === 3
																	? "🥉"
																	: `#${participant.position}`
																: `#${index + 1}`}
														</td>
														<td>
															<strong>{participant.userName}</strong>
															<br />
															<small className="text-muted">{participant.userEmail}</small>
														</td>
														<td>
															<code>{participant.accountId}</code>
														</td>
														<td>
															$
															{parseFloat(participant.currentBalance || 0).toLocaleString("en-US", {
																minimumFractionDigits: 2,
															})}
														</td>
														<td>
															{participant.finishedAt ? (
																<span className="badge bg-success">Finalizado</span>
															) : participant.startedAt ? (
																<span className="badge bg-primary">En Progreso</span>
															) : (
																<span className="badge bg-secondary">Registrado</span>
															)}
														</td>
														<td>
															<small>
																{new Date(participant.registeredAt).toLocaleDateString("es-ES", {
																	day: "2-digit",
																	month: "2-digit",
																	year: "numeric",
																	hour: "2-digit",
																	minute: "2-digit",
																})}
															</small>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								)}
							</div>
							<div className="modal-footer" style={{ borderTop: "1px solid rgba(69, 153, 217, 0.3)" }}>
								<div className="me-auto text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
									<small>
										Total de participantes: <strong>{tournamentParticipants.length}</strong>
										{selectedTournament?.["Max Participantes"] && <> / {selectedTournament["Max Participantes"]}</>}
									</small>
								</div>
								<button
									type="button"
									className="btn"
									style={{
										color: "#fff",
										background: "rgba(69, 153, 217, 0.3)",
										fontFamily: "'Montserrat', sans-serif",
										boxShadow: "inset 0 0 5px #4599d9, inset 0 0 10px #4599d9",
										borderRadius: "8px",
										border: "none",
										transition: "all 0.3s ease",
									}}
									onMouseEnter={(e) => {
										e.target.style.background = "rgba(69, 153, 217, 0.5)";
										e.target.style.boxShadow = "inset 0 0 8px #4599d9, inset 0 0 15px #4599d9";
									}}
									onMouseLeave={(e) => {
										e.target.style.background = "rgba(69, 153, 217, 0.3)";
										e.target.style.boxShadow = "inset 0 0 5px #4599d9, inset 0 0 10px #4599d9";
									}}
									onClick={() => setShowClassificationModal(false)}>
									Cerrar
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default TableBody;
